/* @flow */
import { mutateAsync } from 'redux-query';

import * as t from './actionTypes';
import * as q from './queries';
import type { getPromoCodeOptions } from './queries';

export function setCurrentUser(userId: string, accessToken: string) {
  return {
    type: t.SET_CURRENT_USER,
    userId,
    accessToken,
  };
}

export function logout() {
  return {
    type: t.LOGOUT,
  };
}

export function getPromoCode(options: getPromoCodeOptions) {
  return mutateAsync(q.getPromoCode(options));
}



// WEBPACK FOOTER //
// ./src/redux/current-user/actions.js